import { render, staticRenderFns } from "./DefaultTrafficReport.vue?vue&type=template&id=a952a1f0&scoped=true&"
import script from "./DefaultTrafficReport.vue?vue&type=script&lang=js&"
export * from "./DefaultTrafficReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a952a1f0",
  null
  
)

export default component.exports